// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li>ul[data-v-4cee0fa8]{padding-right:3rem;list-style:none}", ""]);
// Exports
module.exports = exports;
